module.exports = __webpack_public_path__ + "img/installed.88cb28c4.png";